import React from "react";
const InfoIcon = ({
  title,
  className
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, title && /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm.663 6.31h-1.33c-.071 0-.133.024-.187.074-.053.05-.08.114-.08.192v5.002c0 .07.027.133.08.186.054.053.116.08.187.08h1.33c.078 0 .144-.025.197-.075.053-.05.08-.113.08-.191V6.576c0-.078-.027-.142-.08-.192-.053-.05-.119-.074-.197-.074zm0-2.31h-1.33c-.071 0-.133.027-.187.08-.053.053-.08.119-.08.197v.99c0 .078.026.143.075.196.05.054.114.08.192.08h1.33c.078 0 .144-.026.197-.08.053-.053.08-.118.08-.196v-.99c0-.078-.027-.144-.08-.197-.053-.053-.119-.08-.197-.08z"
  })));
};
export default InfoIcon;